export default __webpack_public_path__ + "static/media/md-card-bg-ds.fec580a0.png";